import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FilterStatsService {
  @Output() total = new EventEmitter<number>();
  @Output() totalInLive = new EventEmitter<number>();
  @Output() totalFinished = new EventEmitter<number>();
  @Output() totalBeginNext = new EventEmitter<number>();

  constructor() {}
}
